<template>
  <div height="100%">
    <img src="/static/login_page.png" class="center" height="52%" width="100%">
  </div>
</template>
<script>
export default {
  data () {
    return {
      items: [{src: '/static/login_page.png'}]
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Home.vue